var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{class:_vm.$style.container},[_c('span',{class:_vm.$style.saved,on:{"click":function($event){return _vm.$emit('click')}}},[_c('img',{attrs:{"src":require("../../public/save.svg")}}),_vm._v(" "+_vm._s(_vm.saveButtonLabel))])])
}
var staticRenderFns = []

export { render, staticRenderFns }